// 数学服务配置

import { MathServiceConfig } from './types';

export const getMathConfig = (): MathServiceConfig => {
  return {
    renderer: (import.meta.env.VITE_MATH_RENDERER as any) || 'katex',
    inputEnabled: import.meta.env.VITE_MATH_INPUT_ENABLED === 'true',
    virtualKeyboard: import.meta.env.VITE_MATH_VIRTUAL_KEYBOARD === 'true',
    fallbackEnabled: import.meta.env.VITE_MATH_FALLBACK_ENABLED === 'true',
  };
};

export const isMathInputSupported = (): boolean => {
  // 检查是否支持数学输入
  return typeof window !== 'undefined' && 'customElements' in window;
};

export const isMathRenderSupported = (): boolean => {
  // 检查是否支持数学渲染
  return typeof window !== 'undefined';
};